export default __webpack_public_path__ + "static/media/kn-logo.f35a5a89.svg";